var map = {
	"./About Icon - charcoal.svg": "675d",
	"./About Icon - white.svg": "aa4e",
	"./Add Icon - charcoal.svg": "e8f5",
	"./Add Icon - white.svg": "50ea",
	"./Alcohol Icon - charcoal.svg": "36ef",
	"./Alcohol Icon - white.svg": "b7c6",
	"./Alert Icon - charcoal.svg": "2ce8",
	"./Alert Icon - white.svg": "e8b3",
	"./App orders Icon - charcoal.svg": "32dd",
	"./App orders Icon - white.svg": "567e",
	"./Arrow down Icon - charcoal.svg": "a829",
	"./Arrow down Icon - white.svg": "839a",
	"./Arrow left Icon - charcoal.svg": "4834",
	"./Arrow left Icon - white.svg": "594b",
	"./Arrow up Icon - charcoal.svg": "81b2",
	"./Arrow up Icon - white.svg": "7d02",
	"./Average order value Icon - charcoal.svg": "8477",
	"./Average order value Icon - white.svg": "6bde",
	"./BTL_sRGB_2023_Winter-Warmers_Parmigiana_Macro.png": "2f0b",
	"./Backpack Icon - charcoal.svg": "0efc",
	"./Backpack Icon - white.svg": "6ad5",
	"./Bag Icon - charcoal.svg": "e57c",
	"./Bag Icon - white.svg": "fdbc",
	"./Barcode Icon - charcoal.svg": "3b4c",
	"./Barcode Icon - white.svg": "eb7a",
	"./Basket Icon - charcoal.svg": "d8d8",
	"./Basket Icon - white.svg": "95f3",
	"./Battery Icon - charcoal.svg": "3173",
	"./Battery Icon - white.svg": "df2d",
	"./Benefits Icon - charcoal.svg": "6e1a",
	"./Benefits Icon - white.svg": "09f6",
	"./Bike driver Icon - charcoal.svg": "4685",
	"./Bike driver Icon - white.svg": "7b2f",
	"./Bitcoin Icon - charcoal.svg": "8e50",
	"./Bitcoin Icon - white.svg": "fe8a",
	"./Brand awareness Icon - charcoal.svg": "5809",
	"./Brand awareness Icon - white.svg": "acac",
	"./Broken link Icon - charcoal.svg": "9a8b",
	"./Broken link Icon - white.svg": "7991",
	"./Bug Icon - charcoal.svg": "8491",
	"./Bug Icon - white.svg": "ad96",
	"./Burger and drink Icon - charcoal.svg": "0517",
	"./Burger and drink Icon - white.svg": "ed3e",
	"./Calendar Icon - charcoal.svg": "df4e",
	"./Calendar Icon - white.svg": "01c4",
	"./Camera Icon - charcoal.svg": "73ad",
	"./Camera Icon - white.svg": "cad6",
	"./Car Icon - charcoal.svg": "e653",
	"./Car Icon - white.svg": "e346",
	"./Car driver Icon - charcoal.svg": "e073",
	"./Car driver Icon - white.svg": "550c",
	"./Case presentation Icon - charcoal.svg": "dd07",
	"./Case presentation Icon - white.svg": "8cb9",
	"./Cash Icon - charcoal.svg": "e3d0",
	"./Cash Icon - white.svg": "0643",
	"./Chat Icon - charcoal.svg": "b95d",
	"./Chat Icon - white.svg": "7bad",
	"./Checkbox selected Icon - charcoal.svg": "3da5",
	"./Checkbox selected Icon - white.svg": "4ab1",
	"./Checkbox unselected Icon - charcoal.svg": "77fc",
	"./Checkbox unselected Icon - white.svg": "9d5e",
	"./Cheque Icon - charcoal.svg": "e44b",
	"./Cheque Icon - white.svg": "9994",
	"./Chili Icon - charcoal.svg": "d0b4",
	"./Chili Icon - white.svg": "84ca",
	"./Churned customers Icon - charcoal.svg": "3cbd",
	"./Churned customers Icon - white.svg": "535d",
	"./Clear Icon - charcoal.svg": "0ca6",
	"./Clear Icon - white.svg": "c077",
	"./Closed Icon - charcoal.svg": "3fef",
	"./Closed Icon - white.svg": "8886",
	"./Cloud Icon - charcoal.svg": "15a9",
	"./Cloud Icon - white.svg": "5d9b",
	"./Cloud error Icon - charcoal.svg": "4b86",
	"./Cloud error Icon - white.svg": "c0ef",
	"./Communities Icon - charcoal.svg": "abe6",
	"./Communities Icon - white.svg": "21b7",
	"./Complex-Falafel.png": "cc8f",
	"./Complex-Poke.png": "d729",
	"./Complex-Sushi.png": "96e6",
	"./Complex-Wrap.png": "7906",
	"./Conversion rate Icon - charcoal.svg": "fca0",
	"./Conversion rate Icon - white.svg": "1b42",
	"./Corporate social responsibility Icon - charcoal.svg": "427e",
	"./Corporate social responsibility Icon - white.svg": "777a",
	"./Courier-1.png": "04a5",
	"./Courier-2.png": "7a20",
	"./Courier-3.png": "1a23",
	"./Courier-4.png": "87f0",
	"./Courier-5.png": "712d",
	"./Courier-6.png": "7091",
	"./Creative studio Icon - charcoal.svg": "7ca3",
	"./Creative studio Icon - white.svg": "c8c6",
	"./Credit card Icon - charcoal.svg": "2228",
	"./Credit card Icon - white.svg": "ab26",
	"./Credit card at home Icon - charcoal.svg": "9e9a",
	"./Credit card at home Icon - white.svg": "8227",
	"./Cross Icon - charcoal.svg": "db03",
	"./Cross Icon - white.svg": "cf6e",
	"./Curry Icon - charcoal.svg": "b09f",
	"./Curry Icon - white.svg": "6e3f",
	"./Customer-1.png": "8fe2",
	"./Customer-2.png": "1403",
	"./Customer-3.png": "b2cc",
	"./Customer-4.png": "b016",
	"./Customer-5.png": "fe51",
	"./Customer-6.png": "048a",
	"./Customer-7.png": "e16a",
	"./Customer-8.png": "b8ca",
	"./Cutlery Icon - charcoal.svg": "ff1b",
	"./Cutlery Icon - white.svg": "b12b",
	"./Data protection Icon - charcoal.svg": "8083",
	"./Data protection Icon - white.svg": "8833",
	"./Delete Icon - charcoal.svg": "d9a6",
	"./Delete Icon - white.svg": "c6f5",
	"./Delivery fee Icon - charcoal.svg": "1999",
	"./Delivery fee Icon - white.svg": "71b9",
	"./Delivery location Icon - charcoal.svg": "7ecc",
	"./Delivery location Icon - white.svg": "1db6",
	"./Delivery time Icon - charcoal.svg": "612b",
	"./Delivery time Icon - white.svg": "8449",
	"./Dine-in Icon - charcoal.svg": "cc2e",
	"./Dine-in Icon - white.svg": "451b",
	"./Discount Icon - charcoal.svg": "3da6",
	"./Discount Icon - white.svg": "a174",
	"./Dish Icon - charcoal.svg": "390c",
	"./Dish Icon - white.svg": "ec71",
	"./Do-Contrast_ratio.png": "67b5",
	"./Do_Horizontal_logo.png": "1ab5",
	"./Do_Logo_exclusion.png": "813b",
	"./Dollar Icon - charcoal.svg": "6e78",
	"./Dollar Icon - white.svg": "69d0",
	"./Doner Kebab Icon - charcoal.svg": "d6ce",
	"./Doner Kebab Icon - white.svg": "29a3",
	"./Dont_Busy_backgrounds.png": "6803",
	"./Dont_Shadows_and_gradients.png": "60ba",
	"./Dont_Stretch_warp_compress.png": "b858",
	"./Download Icon - charcoal.svg": "0791",
	"./Download Icon - white.svg": "31b4",
	"./Download cloud Icon - charcoal.svg": "2c17",
	"./Download cloud Icon - white.svg": "ba8b",
	"./Download success Icon - charcoal.svg": "28cc",
	"./Download success Icon - white.svg": "c602",
	"./Drink Icon - charcoal.svg": "6fc1",
	"./Drink Icon - white.svg": "0070",
	"./Ebike Icon - charcoal.svg": "c0b9",
	"./Ebike Icon - white.svg": "7b6d",
	"./Edit Icon - charcoal.svg": "4340",
	"./Edit Icon - white.svg": "6ea3",
	"./Efficiency Icon - charcoal.svg": "d893",
	"./Efficiency Icon - white.svg": "b9e0",
	"./Email Icon - charcoal.svg": "cc79",
	"./Email Icon - white.svg": "db4c",
	"./Employee directory Icon - charcoal.svg": "53be",
	"./Employee directory Icon - white.svg": "f08b",
	"./Employee-1.png": "9bc4",
	"./Employee-2.png": "e5fc",
	"./Employees-1.png": "b6ca",
	"./Euro Icon - charcoal.svg": "dd85",
	"./Euro Icon - white.svg": "d109",
	"./Facebook Icon - charcoal.svg": "fb23",
	"./Facebook Icon - white.svg": "3cc2",
	"./Filter Icon - charcoal.svg": "646a",
	"./Filter Icon - white.svg": "38ae",
	"./Freeze Icon - charcoal.svg": "2def3",
	"./Freeze Icon - white.svg": "bd82",
	"./Fried chicken Icon - charcoal.svg": "3e46",
	"./Fried chicken Icon - white.svg": "8fa1",
	"./Fries Icon - charcoal.svg": "9bba",
	"./Fries Icon - white.svg": "15e0",
	"./Geolocation Icon - charcoal.svg": "fdec",
	"./Geolocation Icon - white.svg": "0898",
	"./Geolocation web Icon - charcoal.svg": "047a",
	"./Geolocation web Icon - white.svg": "64a5",
	"./Google voice Icon - charcoal.svg": "1fbe",
	"./Google voice Icon - white.svg": "402a",
	"./Grid view Icon - charcoal.svg": "90db",
	"./Grid view Icon - white.svg": "04f6",
	"./Grouped order Icon - charcoal.svg": "ca09",
	"./Grouped order Icon - white.svg": "73cd",
	"./Hackathon Icon - charcoal.svg": "dbb5",
	"./Hackathon Icon - white.svg": "6d8c",
	"./Headset Icon - charcoal.svg": "f0ce",
	"./Headset Icon - white.svg": "35f5",
	"./Heart Icon - charcoal.svg": "ee31",
	"./Heart Icon - white.svg": "3bfe",
	"./Helmet Icon - charcoal.svg": "41f6",
	"./Helmet Icon - white.svg": "6a39",
	"./Hide Icon - charcoal.svg": "2994",
	"./Hide Icon - white.svg": "7322",
	"./Home Icon - charcoal.svg": "8bea",
	"./Home Icon - white.svg": "dbd6",
	"./Ice cream Icon - charcoal.svg": "c58f",
	"./Ice cream Icon - white.svg": "cdbd",
	"./Image Icon - charcoal.svg": "4674",
	"./Image Icon - white.svg": "50dd",
	"./Info Icon - charcoal.svg": "ca8d",
	"./Info Icon - white.svg": "c41b",
	"./Insiders Icon - charcoal.svg": "7691",
	"./Insiders Icon - white.svg": "f987",
	"./Instagram Icon - charcoal.svg": "30bc",
	"./Instagram Icon - white.svg": "7b1b",
	"./Interview Icon - charcoal.svg": "4b9d",
	"./Interview Icon - white.svg": "bb95",
	"./Iphone_Cam_03-Final-Cupcake.png": "4929",
	"./JET-Sans-digital.svg": "f385",
	"./Kebab wrap Icon - charcoal.svg": "0876",
	"./Kebab wrap Icon - white.svg": "a148",
	"./Kosher Icon - charcoal.svg": "e72c",
	"./Kosher Icon - white.svg": "46fb",
	"./Language Icon - charcoal.svg": "5be1",
	"./Language Icon - white.svg": "54ab",
	"./Laptop Icon - charcoal.svg": "58fc",
	"./Laptop Icon - white.svg": "4df2",
	"./Lei Icon - charcoal.svg": "f2f0",
	"./Lei Icon - white.svg": "53b4",
	"./Lev Icon - charcoal.svg": "2954",
	"./Lev Icon - white.svg": "7c68",
	"./Lifestyle_H_RGB_Global_2022_RestaurantAwards_PokePrep.png": "576e",
	"./Link Icon - charcoal.svg": "4577",
	"./Link Icon - white.svg": "eed1",
	"./Linkedin Icon - charcoal.svg": "a871",
	"./Linkedin Icon - white.svg": "9f37",
	"./List Icon - charcoal.svg": "1c44",
	"./List Icon - white.svg": "e732",
	"./Loading Icon - charcoal.svg": "9bc8",
	"./Loading Icon - white.svg": "bcc3",
	"./Location Icon - charcoal.svg": "692a",
	"./Location Icon - white.svg": "a963",
	"./Lock Icon - charcoal.svg": "2c8d",
	"./Lock Icon - white.svg": "8f02",
	"./Locked Icon - charcoal.svg": "a55f",
	"./Locked Icon - white.svg": "c2e6",
	"./Locker Icon - charcoal.svg": "739c",
	"./Locker Icon - white.svg": "0138",
	"./Logo_Hor_Mozza.png": "c608",
	"./Logo_Hor_Orange.png": "2c29",
	"./Logo_House.png": "33a0",
	"./Logout Icon - charcoal.svg": "a760",
	"./Logout Icon - white.svg": "913b",
	"./Loyalty Icon - charcoal.svg": "ffd9",
	"./Loyalty Icon - white.svg": "00fe",
	"./Loyalty gift box Icon - charcoal.svg": "167c",
	"./Loyalty gift box Icon - white.svg": "a41b",
	"./Market share Icon - charcoal.svg": "500a",
	"./Market share Icon - white.svg": "de69",
	"./Marketing target Icon - charcoal.svg": "efff",
	"./Marketing target Icon - white.svg": "7270",
	"./Meal voucher Icon - charcoal.svg": "5d83",
	"./Meal voucher Icon - white.svg": "cb4f",
	"./Meet the team Icon - charcoal.svg": "d206",
	"./Meet the team Icon - white.svg": "8921",
	"./Microphone Icon - charcoal.svg": "4724",
	"./Microphone Icon - white.svg": "f91d",
	"./More Icon - charcoal.svg": "f231",
	"./More Icon - white.svg": "af53",
	"./Nachos Icon - charcoal.svg": "ea40",
	"./Nachos Icon - white.svg": "fb43",
	"./Nav_House.png": "119f",
	"./Nav_Logo.png": "c9c4",
	"./New customer Icon - charcoal.svg": "6d48",
	"./New customer Icon - white.svg": "b734",
	"./Noodles Icon - charcoal.svg": "84f2",
	"./Noodles Icon - white.svg": "d4f6",
	"./Notification Icon - charcoal.svg": "c228",
	"./Notification Icon - white.svg": "1dee",
	"./Object-1.png": "1b5b",
	"./Object-2.png": "5b3d",
	"./Object-3.png": "1ccc",
	"./Object-4.png": "1c5e",
	"./Object-D.png": "c30e",
	"./Object-E.png": "6946",
	"./Object-F.png": "3769",
	"./Office Icon - charcoal.svg": "04be",
	"./Office Icon - white.svg": "b3cc",
	"./Online payment Icon - charcoal.svg": "dc86",
	"./Online payment Icon - white.svg": "f522",
	"./Online restaurants Icon - charcoal.svg": "e2a9",
	"./Online restaurants Icon - white.svg": "5974",
	"./Orders Icon - charcoal.svg": "4e1b",
	"./Orders Icon - white.svg": "4657",
	"./Partnership Icon - charcoal.svg": "b0b1",
	"./Partnership Icon - white.svg": "0919",
	"./Peanut Icon - charcoal.svg": "bbd8",
	"./Peanut Icon - white.svg": "4025",
	"./Percentage Icon - charcoal.svg": "ba5e",
	"./Percentage Icon - white.svg": "ccd1",
	"./Person Icon - charcoal.svg": "2e1d",
	"./Person Icon - white.svg": "66c8",
	"./Personality test Icon - charcoal.svg": "82e1",
	"./Personality test Icon - white.svg": "f05b",
	"./Phone Icon - charcoal.svg": "77e0",
	"./Phone Icon - white.svg": "1ae5",
	"./Pickup Icon - charcoal.svg": "13df",
	"./Pickup Icon - white.svg": "1f30",
	"./Pin at home Icon - charcoal.svg": "14ef",
	"./Pin at home Icon - white.svg": "c6a7",
	"./Pizza Icon - charcoal.svg": "8978",
	"./Pizza Icon - white.svg": "dbec",
	"./Policies Icon - charcoal.svg": "a2d2",
	"./Policies Icon - white.svg": "6452",
	"./Pound Icon - charcoal.svg": "7f7c",
	"./Pound Icon - white.svg": "7ac8",
	"./Printer Icon - charcoal.svg": "1493",
	"./Printer Icon - white.svg": "b702",
	"./Profile Icon - charcoal.svg": "6853",
	"./Profile Icon - white.svg": "6338",
	"./Profile face Icon - charcoal.svg": "d5f9",
	"./Profile face Icon - white.svg": "9f7e",
	"./Question Icon - charcoal.svg": "314c",
	"./Question Icon - white.svg": "501f",
	"./Radio selected Icon - charcoal.svg": "707e",
	"./Radio selected Icon - white.svg": "7fdb",
	"./Recycle Icon - charcoal.svg": "1de5",
	"./Recycle Icon - white.svg": "7df7",
	"./Refresh Icon - charcoal.svg": "78b8",
	"./Refresh Icon - white.svg": "bac3",
	"./Remove Icon - charcoal.svg": "8fa3",
	"./Remove Icon - white.svg": "5c71",
	"./Restaurant Icon - charcoal.svg": "efa1",
	"./Restaurant Icon - white.svg": "b76e",
	"./Restaurant location Icon - charcoal.svg": "034f",
	"./Restaurant location Icon - white.svg": "c52b",
	"./Restaurant location pin Icon - charcoal.svg": "5757",
	"./Restaurant location pin Icon - white.svg": "2d56",
	"./Restaurant-Facade.png": "7bb2",
	"./RestoPartner-1.png": "9b84",
	"./RestoPartner-2.png": "277a",
	"./Revenue Icon - charcoal.svg": "4ba2",
	"./Revenue Icon - white.svg": "a302",
	"./Revenue per order Icon - charcoal.svg": "38fa",
	"./Revenue per order Icon - white.svg": "e7c7",
	"./Review Icon - charcoal.svg": "804d",
	"./Review Icon - white.svg": "3717",
	"./Ribbon Icon - charcoal.svg": "7d68",
	"./Ribbon Icon - white.svg": "a14f",
	"./Rocket ship Icon - charcoal.svg": "89f9",
	"./Rocket ship Icon - white.svg": "7f3b",
	"./Salad Icon - charcoal.svg": "87e5",
	"./Salad Icon - white.svg": "478d",
	"./Sales Icon - charcoal.svg": "23ae",
	"./Sales Icon - white.svg": "e76c",
	"./Sandwich Icon - charcoal.svg": "0c68",
	"./Sandwich Icon - white.svg": "bf36",
	"./Scooter Icon - charcoal.svg": "e873",
	"./Scooter Icon - white.svg": "a6f7",
	"./Search Icon - charcoal.svg": "a919",
	"./Search Icon - white.svg": "f00e",
	"./Settings Icon - charcoal.svg": "5e20",
	"./Settings Icon - white.svg": "723c",
	"./Share Icon - charcoal.svg": "387a",
	"./Share Icon - white.svg": "095d",
	"./Share of voice Icon - charcoal.svg": "f8f4",
	"./Share of voice Icon - white.svg": "dc19",
	"./Shekel Icon - charcoal.svg": "e0dd",
	"./Shekel Icon - white.svg": "c78d",
	"./Show Icon - charcoal.svg": "a08d",
	"./Show Icon - white.svg": "7101",
	"./Simple-Burger.png": "67f5",
	"./Simple-Drink.png": "d8d6",
	"./Simple-Fries.png": "2588",
	"./Simple-Macaroni.png": "e128",
	"./Simple-Mash.png": "7ca1",
	"./Simple-Noodles.png": "a60c",
	"./Simple-Pizza.png": "4e92",
	"./Simple-Ramen.png": "e56e",
	"./Simple-Salad.png": "3e14",
	"./Simple-Sushi.png": "0931",
	"./Simple-Taco.png": "bcaf",
	"./Small house logo Icon - charcoal.svg": "dc2b",
	"./Small house logo Icon - white.svg": "8cc4",
	"./Snapchat Icon - charcoal.svg": "c984",
	"./Snapchat Icon - white.svg": "dee0",
	"./Sort Icon - charcoal.svg": "566a",
	"./Sort Icon - white.svg": "dea6",
	"./Sound Icon - charcoal.svg": "4f20",
	"./Sound Icon - white.svg": "5abf",
	"./Split chevron Icon - charcoal.svg": "b0cb",
	"./Split chevron Icon - white.svg": "e287",
	"./Sponsored Icon - charcoal.svg": "243a",
	"./Sponsored Icon - white.svg": "2aa1",
	"./Stampcard 10 Icon - charcoal.svg": "fcd2",
	"./Stampcard 10 Icon - white.svg": "9d3a",
	"./Star rating Icon - charcoal.svg": "c8a3",
	"./Star rating Icon - white.svg": "73c3",
	"./Support-1.png": "fe1f",
	"./Support-2.png": "06d9",
	"./Support-3.png": "7c3a",
	"./Support-4.png": "a95d",
	"./Support-5.png": "7674",
	"./Sushi Icon - charcoal.svg": "42b9",
	"./Sushi Icon - white.svg": "f46a",
	"./Swiss frank Icon - charcoal.svg": "557c",
	"./Swiss frank Icon - white.svg": "b28e",
	"./T and C Icon - charcoal.svg": "03fe",
	"./T and C Icon - white.svg": "1fb3",
	"./T-box Icon - charcoal.svg": "77be",
	"./T-box Icon - white.svg": "8b0e1",
	"./Taco Icon - charcoal.svg": "c25b",
	"./Taco Icon - white.svg": "c0fc",
	"./Takeaway Pay Icon - charcoal.svg": "0031",
	"./Takeaway Pay Icon - white.svg": "076a",
	"./Tech test Icon - charcoal.svg": "3e75",
	"./Tech test Icon - white.svg": "3974",
	"./Technology Icon - charcoal.svg": "1b26",
	"./Technology Icon - white.svg": "e68c",
	"./Temperature Icon - charcoal.svg": "dc88",
	"./Temperature Icon - white.svg": "197e",
	"./Thumbs up Icon - charcoal.svg": "a4d5",
	"./Thumbs up Icon - white.svg": "7309",
	"./Tick Icon - charcoal.svg": "166a",
	"./Tick Icon - white.svg": "7c9c",
	"./Tiktok Icon - charcoal.svg": "bb3b",
	"./Tiktok Icon - white.svg": "5dc6",
	"./Toilet Icon - charcoal.svg": "a2ff",
	"./Toilet Icon - white.svg": "4312",
	"./Travel Icon - charcoal.svg": "be46",
	"./Travel Icon - white.svg": "73cb",
	"./Trial day Icon - charcoal.svg": "d434",
	"./Trial day Icon - white.svg": "6d43",
	"./Twitter Icon - charcoal.svg": "a030",
	"./Twitter Icon - white.svg": "49fd",
	"./Under 16 Icon - charcoal.svg": "37f2",
	"./Under 16 Icon - white.svg": "c9b3",
	"./Under 18 Icon - charcoal.svg": "b9e3",
	"./Under 18 Icon - white.svg": "37f6",
	"./Under 21 Icon - charcoal.svg": "f22e",
	"./Under 21 Icon - white.svg": "87d6",
	"./Upload Icon - charcoal.svg": "0aa0",
	"./Upload Icon - white.svg": "cf95",
	"./User welcome Icon - charcoal.svg": "935b",
	"./User welcome Icon - white.svg": "7ce4",
	"./Vegan Icon - charcoal.svg": "c188",
	"./Vegan Icon - white.svg": "5cd5",
	"./Vegetarian Icon - charcoal.svg": "28b3",
	"./Vegetarian Icon - white.svg": "a8b0",
	"./Video interview Icon - charcoal.svg": "c843",
	"./Video interview Icon - white.svg": "6300",
	"./Vision strategy values Icon - charcoal.svg": "b12d",
	"./Vision strategy values Icon - white.svg": "8f783",
	"./Voucher Icon - charcoal.svg": "d9be",
	"./Voucher Icon - white.svg": "5f96",
	"./Warning Icon - charcoal.svg": "3b00",
	"./Warning Icon - white.svg": "4391",
	"./Web Menu Icon - charcoal.svg": "2891",
	"./Web Menu Icon - white.svg": "fa64",
	"./Weekly payment Icon - charcoal.svg": "8bb6",
	"./Weekly payment Icon - white.svg": "73f2",
	"./Wifi Icon - charcoal.svg": "b51f",
	"./Wifi Icon - white.svg": "8745",
	"./World map Icon - charcoal.svg": "0f44",
	"./World map Icon - white.svg": "068f",
	"./Wrap Icon - charcoal.svg": "4ab0",
	"./Wrap Icon - white.svg": "1769",
	"./Youtube Icon - charcoal.svg": "1738",
	"./Youtube Icon - white.svg": "59b0",
	"./alt.png": "8f39",
	"./arrow-black.svg": "8d65",
	"./arrow-down.svg": "76bd",
	"./arrow-left.svg": "337d",
	"./arrow-right.svg": "e524",
	"./arrow-white.svg": "714a",
	"./arrow.svg": "27e4",
	"./art-direction-tips.png": "9a52",
	"./associated-brand.png": "40b8",
	"./associated-brands.png": "f756",
	"./bao.gif": "f5f2",
	"./base-colours.png": "9b3f",
	"./bike-man.png": "8c16",
	"./bike-woman.png": "7e8e",
	"./bike.png": "a3ca",
	"./blt.png": "869d",
	"./box-down.svg": "ddb8",
	"./box-up.svg": "77f5",
	"./brand-voice.png": "63bf",
	"./burger-charcoal.svg": "0a26",
	"./burger-orange.svg": "c4bd",
	"./burger-white.svg": "9cd3",
	"./burger.png": "d957",
	"./burrito-bowl.png": "2fda",
	"./busy-background.png": "ccab",
	"./check-white.svg": "eb92",
	"./chicken-hero.gif": "9da1",
	"./chicken-home.png": "dd6b",
	"./chicken.gif": "7221",
	"./chinese.png": "a908",
	"./co-branding-logo-KFC.png": "6708",
	"./co-branding-logo-ben-jerrys.png": "6122",
	"./co-branding-logo-burger-king.png": "cdd5",
	"./co-branding-logo-dominoes.png": "9b45",
	"./co-branding-logo-dunkin.png": "6bb1",
	"./co-branding-logo-greggs.png": "0da9",
	"./co-branding-logo-mcdonalds.png": "b2cc9",
	"./co-branding-logo-papa-johns.png": "7972",
	"./co-branding-logo-starbucks.png": "4fde",
	"./co-branding-logo-subway.png": "107f",
	"./co-branding-logo-tacobell.png": "374b",
	"./co-branding-logos-intro.png": "3b7b",
	"./co-branding-logos-primary.png": "caa4",
	"./co-branding-logos-secondary.gif": "ad3e",
	"./co-branding-orange-background.png": "07cc",
	"./co-branding-razor.png": "f36f",
	"./co-branding-tab.gif": "9061",
	"./co-branding-world-JET-1.gif": "164a",
	"./co-branding-world-JET-2.gif": "984c",
	"./co-branding-world-JET-3.gif": "245d",
	"./co-branding-world-JET-4.png": "262b",
	"./co-branding-world-JET-background-1.png": "aa1f",
	"./co-branding-world-JET-background-2.png": "d4de",
	"./co-branding-world-JET-background-3.png": "3fd7",
	"./co-branding-world-RP-1.gif": "6394",
	"./co-branding-world-RP-2.png": "10e1",
	"./co-branding-world-RP-background-4.png": "a0d6",
	"./co-branding-world-RP-background-5.png": "3cda",
	"./co-branding-world-RP-background.png": "449e",
	"./co-branding.png": "938f",
	"./cobranding-16x9.png": "2f2d",
	"./cobranding.png": "37193",
	"./cobrandingnew.png": "9d9e",
	"./color-palette-mobile.png": "3784",
	"./color-palette.png": "65f4",
	"./color-picker.svg": "0a5d",
	"./colors-hero.png": "eeff",
	"./colour-aubergine.png": "055a",
	"./colour-base-colours.png": "461c",
	"./colour-berry.png": "a666",
	"./colour-charcoal.png": "5118",
	"./colour-cupcake.png": "4408",
	"./colour-how-much-orange.gif": "a99f",
	"./colour-mozzarella.png": "5353",
	"./colour-orange.png": "6e7d",
	"./colour-tomato.png": "e060",
	"./colour-turmeric.png": "f5f5",
	"./colours-bg.png": "2440",
	"./colours-hero.jpeg": "8944",
	"./colours-nav.png": "746e",
	"./colours.png": "72d4",
	"./composition-16x9.png": "59a9",
	"./composition-cards-animation.gif": "3a53",
	"./composition-grid-animation.gif": "5b86",
	"./composition-nav.png": "6d99",
	"./composition-razor-animation.gif": "398c",
	"./composition.png": "b7f7",
	"./contrast-ratio.png": "ee9f",
	"./cookies.png": "c0e2",
	"./corner-house.png": "7900",
	"./corporate-image.png": "f72d",
	"./corporate.png": "f026",
	"./courier-7.png": "ded9",
	"./courier-image.png": "5345",
	"./courier.png": "e533",
	"./cross-white.svg": "86d0",
	"./cross.svg": "4915",
	"./custom-grid.png": "901f",
	"./disposables.png": "27a2",
	"./doughnut.png": "e4b3",
	"./dounuts.png": "75c9",
	"./down-arrow.svg": "a9bb",
	"./download-charcoal.svg": "cd37",
	"./download-orange-horizontal.png": "e9d7",
	"./download-orange-house.png": "becb",
	"./download-orange-stacked.png": "3bdb",
	"./download-white-horizontal.png": "4ed8",
	"./download-white-stacked.png": "a3d2",
	"./download-white.svg": "234f",
	"./download.svg": "c482",
	"./drink-charcoal.svg": "f01a",
	"./drink.svg": "51af",
	"./dropper.png": "7fc5",
	"./dropper.svg": "3017",
	"./edamame.gif": "ecb4",
	"./food-image.png": "50d4",
	"./food.png": "1419",
	"./grid.svg": "afb3",
	"./hero-video-2024.mp4": "60ed",
	"./hero-video-more-2024.mp4": "3daa",
	"./hero-video-more.mp4": "5ea4",
	"./hero-video.mp4": "09d0",
	"./horizontal-logo.png": "344a",
	"./house-orange.png": "e5ad",
	"./house-square.png": "d359",
	"./house-white.png": "ddcd",
	"./hybrid-dessert.png": "8c0f",
	"./hybrid-image-1.png": "bc1f",
	"./hybrid-image-2.png": "e8a8",
	"./hybrid-image-3.png": "29e1",
	"./hybrid-valentines.png": "db9b",
	"./iPhone-2024.png": "34cf",
	"./icecream.gif": "7212",
	"./icon-base-colour.png": "f1f6",
	"./icon-base.png": "e769",
	"./icon-custom-grid.png": "1105",
	"./icon-palette.svg": "d042",
	"./icon-promo-badge-charcoal.png": "b1d1",
	"./icon-promo-badge-mozzarella.png": "8b4c",
	"./icons-nav.png": "6b82",
	"./icons.png": "c42d",
	"./illustration-categories-1-mobile.gif": "e405",
	"./illustration-categories-2-mobile.gif": "dfbd",
	"./illustration-categories-3-mobile.gif": "cead",
	"./illustration-categories.gif": "6c6d",
	"./illustration-colours.png": "af65",
	"./illustration-falafel.png": "4b9b",
	"./illustration-simple-and-complex.png": "8053",
	"./illustration.png": "8518",
	"./info-and-maps.png": "cd14",
	"./info.png": "7c12",
	"./infographic.png": "69ee",
	"./iphone.png": "eea5",
	"./katy-perry.png": "39d5",
	"./laptop-mobile.png": "0fc3",
	"./laptop.png": "1104",
	"./left-white.svg": "b351",
	"./left.svg": "39c2",
	"./link.svg": "b434",
	"./loading-circles.gif": "de0a",
	"./lock-black.svg": "32a1",
	"./lock.svg": "d3cc",
	"./logo-exclusion-zone.png": "4385",
	"./logo-exclusion.png": "9c84",
	"./logo-gif-global-corporate.gif": "4c72",
	"./logo-gif-markets.gif": "6e75",
	"./logo-gif-sub-brands-products.gif": "c882",
	"./logo-image-1.png": "f5b2",
	"./logo-image-2.png": "569f",
	"./logo-image-3.png": "bec0",
	"./logo-image-4.png": "855f",
	"./logo-image-5.png": "c2e5",
	"./logo-minimum-sizes.png": "2def",
	"./logo-orange.png": "3719",
	"./logo-white.png": "06f1",
	"./logos-hero.png": "a4b2",
	"./logos-nav.png": "4c32",
	"./logos.png": "4073",
	"./meeting.png": "2917",
	"./mexican.png": "6ea6",
	"./milkshake.png": "cbc3",
	"./milkshakes.png": "a7eb",
	"./motion.png": "c5b9",
	"./moving-home.png": "d494",
	"./nachos-charcoal.svg": "82d5",
	"./nachos.svg": "7909",
	"./network-teams.png": "8900",
	"./new-food-burger.png": "f6f7",
	"./new-food-drink.png": "8aae",
	"./new-food-fries.png": "d4d7",
	"./new-food-indian.png": "c820",
	"./new-food-noodles.png": "bb47",
	"./new-food-pasta.png": "8e7f",
	"./new-food-pizza.png": "f72b",
	"./new-food-salad.png": "900d",
	"./new-food-sushi.png": "ccb2",
	"./new-food-taco.png": "62a3",
	"./new-food-thai.png": "fd28",
	"./new-object-bag.png": "9ace",
	"./new-object-ballons.png": "cc1e",
	"./new-object-celebration.png": "aa30",
	"./new-object-delivery.png": "eff7",
	"./new-object-joyful.png": "984a",
	"./new-object-lock.png": "5438",
	"./new-object-megaphone.png": "d3b0",
	"./new-object-order.png": "3c29",
	"./new-object-search.png": "1795",
	"./new-object-speech.png": "e902",
	"./new-people-chef-holding-bags.png": "1830",
	"./new-people-chef-order-pad.png": "c9c0",
	"./new-people-courier-bike.png": "3ea4",
	"./new-people-courier-delivery.png": "dd95",
	"./new-people-courier-walk.png": "6983",
	"./new-people-customer-employee-branding.png": "c1f1",
	"./new-people-customer-order-joy.png": "1926",
	"./new-people-customer-using-app.png": "af5d",
	"./new-people-employee-support.png": "6dd1",
	"./new-people-jet-employee.png": "bb81",
	"./no.svg": "fe77",
	"./open.svg": "b8b6",
	"./orange-15.png": "7c34",
	"./orange-30.png": "c6b0",
	"./orange-7.5.png": "e0f1",
	"./orange-circle.png": "d755",
	"./orange-cross.svg": "be83",
	"./orange-horizontal.png": "32be",
	"./orange-house.png": "43f7",
	"./orange-razor.png": "617e",
	"./orange-stacked.png": "004b",
	"./pad-thai.png": "7ff3",
	"./photo-casting.png": "1394",
	"./photo-colour.png": "be00",
	"./photo-courier.jpg": "6ac9",
	"./photo-courier.png": "b33f",
	"./photo-donut-lifestyle.png": "df3c",
	"./photo-donut-studio.png": "16c5",
	"./photo-food-moments.jpg": "82b6",
	"./photo-food-moments.png": "8f2e",
	"./photo-life-studio.png": "0b8d",
	"./photo-lifestyle-casting.png": "73fe",
	"./photo-lifestyle-colour.png": "c651",
	"./photo-lifestyle-courier.jpg": "a253",
	"./photo-lifestyle-food-moments.png": "3cac",
	"./photo-lifestyle-lighting.png": "7d25",
	"./photo-lifestyle-location.png": "f530",
	"./photo-lifestyle-office.jpeg": "311e",
	"./photo-lifestyle-props.png": "dc65",
	"./photo-lifestyle-resto-partner.png": "0cda",
	"./photo-lighting.png": "152f",
	"./photo-location.png": "3b14",
	"./photo-office.png": "7707",
	"./photo-party-studio.jpg": "250e",
	"./photo-party-studio.png": "0ee1",
	"./photo-props.png": "fe7d",
	"./photo-restaurant-partner.jpg": "9f0d",
	"./photo-restaurant-partner.png": "499a",
	"./photo-smoothie-studio.png": "72af",
	"./photo-spectrum-line-mobile.png": "3050",
	"./photo-spectrum-line.png": "8f78",
	"./photo-studio-art-direction.gif": "7817",
	"./photo-studio-atl-btl.png": "4057",
	"./photo-studio-carousel.gif": "8b1b",
	"./photo-studio-lighting.png": "e5df",
	"./photo-studio-pizza-crumbs.png": "8dc5",
	"./photo-studio-razor-15.png": "8c8e",
	"./photo-studio-razor-30.png": "edab",
	"./photo-studio-razor-7.5.png": "b93a",
	"./photography-16x9.png": "dc7e",
	"./photography.png": "274a",
	"./pizza-day.png": "b04d",
	"./pizza-plate.png": "e3a7",
	"./pizza.png": "7237",
	"./presentation-hero.png": "f118",
	"./presentation.png": "0f9c",
	"./press-hero.jpg": "faeb",
	"./press-media-hero.png": "d276",
	"./press.png": "b3e4",
	"./product.png": "52bb",
	"./rainbow-sushi.png": "c93a",
	"./ramen.png": "3e19",
	"./recently-moved.png": "9354",
	"./refresh.svg": "f3f4",
	"./resto-world-gif.gif": "2f6c",
	"./right-white.svg": "9c9c",
	"./right.svg": "9635",
	"./sandwich.svg": "76c8",
	"./search-dots.svg": "d4a3",
	"./shadows-and-gradients.png": "9a48",
	"./shape-or-container.png": "303b",
	"./social-media.png": "5df5",
	"./square.svg": "b98a",
	"./stamp card 32 Icon - charcoal.svg": "7b2a",
	"./stamp card 32 Icon - white.svg": "df6d",
	"./stretch-warp-compress.png": "432a",
	"./sushi-charcoal.svg": "9732",
	"./sushi-image.png": "e0a4",
	"./sushi.png": "db28",
	"./sushi.svg": "69b6",
	"./taco-yellow.png": "135d",
	"./taco.png": "928e",
	"./tacos.png": "13e2",
	"./thumb-down.svg": "7f23",
	"./thumb-up.svg": "324d",
	"./tomato-left.png": "463f",
	"./tomato-right.png": "3e9b",
	"./type-nav.png": "feac",
	"./typography-alignment.gif": "8957",
	"./typography-image-1.png": "f630",
	"./typography-image-2.png": "7a2c",
	"./typography.png": "4216",
	"./up-arrow.svg": "5743",
	"./white-arrow-down.svg": "1cd6",
	"./white-down-arrow.svg": "e2ce",
	"./white-horizontal-mobile.png": "3ff9",
	"./white-horizontal.png": "7c2f",
	"./white-house-mobile.png": "ea42",
	"./white-stacked-mobile.png": "31ac",
	"./white-stacked.png": "368a",
	"./white-tick.svg": "fbcc",
	"./woman-bag.png": "2a21",
	"./woman-helmet.png": "b99b",
	"./woman-noodles.png": "6808",
	"./women.jpg": "fa62",
	"./yellow-bg.png": "52e3",
	"./yes-check.svg": "efe4",
	"./yes.svg": "371f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";